import React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { blue, red } from '@material-ui/core/colors';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    cls1: {
      fill: 'none'
    },
    cls2: {
      fill: 'none',
      stroke: '#686868',
      'stroke-width': '2px'
    },
    cls3: {
      fill: '#686868',
      'fillRule': 'evenodd'
    }
  }),
);

function IconBlockchain(props: SvgIconProps) {
  const classes = useStyles();
  return (
    <SvgIcon {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <defs>
            <filter id="a" width="112.5%" height="102.2%" x="-6.2%" y="-1.1%" filterUnits="objectBoundingBox">
                <feOffset dx="2" in="SourceAlpha" result="shadowOffsetOuter1"/>
                <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="3"/>
                <feColorMatrix in="shadowBlurOuter1" result="shadowMatrixOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0"/>
                <feMerge>
                    <feMergeNode in="shadowMatrixOuter1"/>
                    <feMergeNode in="SourceGraphic"/>
                </feMerge>
            </filter>
        </defs>
        <g fill="none" fillRule="evenodd" filter="url(#a)">
            <path d="M0 0h24v24H0z"/>
            <rect width="5" height="5" x="4" y="4" stroke={props.htmlColor || '#000'} strokeWidth="2" rx="2"/>
            <rect width="5" height="5" x="4" y="15" stroke={props.htmlColor || '#000'} strokeWidth="2" rx="2"/>
            <rect width="5" height="5" x="15" y="15" stroke={props.htmlColor || '#000'} strokeWidth="2" rx="2"/>
            <rect width="5" height="5" x="15" y="4" stroke={props.htmlColor || '#000'} strokeWidth="2" rx="2"/>
            <path stroke={props.htmlColor || '#000'} strokeWidth="2" d="M8.51 6.5h6.99M8.51 17.5h6.99M17.5 8.51v6.99M6.5 8.51v6.99"/>
        </g>
    </svg>
    </SvgIcon>
  );
}

export default IconBlockchain;